module.exports = __webpack_public_path__ + "assets/app-store-it.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/stores/app-store-it.svg
// module id = 436
// module chunks = 19